import React, { useState } from "react";
import "../styles/LearnerDashboard.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Tutorials from "../components/Tutorials";

import { learnerMenuItems } from "../components/TeacherMenuItems"; // Import menu items
import AccessTokenModal from "../components/AccessTokenModal";
const TutorialsPage = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item
    resetSearch(); // Reset search whenever a new section is selected
  };

  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={(query) => setSearchQuery(query)}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={learnerMenuItems}
          resetSearch={resetSearch}
        />

        <div className="content">
          <Tutorials searchQuery={searchQuery} />;
        </div>
      </main>
      <AccessTokenModal />
    </div>
  );
};

export default TutorialsPage;
